/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AnteprimaContributoDTO { 
    calcolabile?: boolean;
    motivo_non_calcolabile?: string;
    scalare_esempio?: number;
    importo?: number;
    coperto?: boolean;
}

